export const options = {
  paging: true,
  select: true,
  autoWidth: true,
  serverSide: true,
  processing: true,
  order: [],
  columnDefs: [{ targets: "_all", orderable: true }],
  lengthMenu: [5, 10, 20, 40, 80, 160, 200],
  pagingType: "simple_numbers",
  language: {
    lengthMenu: "Show _MENU_ entries",
    paginate: {
      next: "Next",
      previous: "Previous",
    },
    info: "Showing _START_ to _END_ of _TOTAL_ entries",
  },
  dom:
    "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>>" +
    "<'row'<'col-sm-12'B>>" +
    "<'row'<'col-sm-12'tr>>" +
    "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 d-flex justify-content-end'p>>",
  buttons: [
    {
      text: "Select All",
      action: function (_, dt) {
        dt.rows().select();
      },
    },
    {
      text: "Deselect All",
      action: function (_, dt) {
        dt.rows().deselect();
      },
    },
    {
      extend: "csvHtml5",
      text: "CSV",
      title: "Central",
      exportOptions: {
        columns: [1, 2, 3, 4, 5, 6],
      },
    },
  ],
};

export const columns = [
  { title: "id", data: "id", visible: false },
  { title: "Name", data: "name" },
  { title: "URL", data: "url" },
  {
    title: "Web Branch",
    data: "web_branch",
    render: (data, type, row) => {
      if (!row) return data || "";
      return row.version
        ? `${row.version} - ${row.web_branch || ""}`
        : row.web_branch || "";
    },
  },
  {
    title: "Server Branch",
    data: "server_branch",
    render: (data, type, row) => {
      if (!row) return data || "Unavailable";
      const branch = row.server_branch || data;
      if (!branch) return "Unavailable";
      return row.app_version ? `${row.app_version} - ${branch}` : branch;
    },
  },
  { title: "Holes", data: "holes" },
  { title: "Provider", data: "tee_provider" },
  {
    title: "Action",
    data: null,
    defaultContent: "",
    orderable: false,
    render: (data) => {
      const rowData = JSON.stringify(data).replace(/"/g, "&quot;");
      const isSetupComplete = data && data.setup_complete === 1;
      const hasUrl = !!(data && data.hasUrl);

      if (isSetupComplete || (!isSetupComplete && !hasUrl)) {
        return `<button
          class="btn btn-warning view-course-btn w-100" data="${rowData}"
        >VIEW</button>`;
      }
      if (!isSetupComplete && hasUrl) {
        const tooltip = "Course setup in progress";

        return `<span
          class="d-inline-block w-100 course-view-tooltip"
          data-tooltip="${tooltip}"
        >
          <button
            class="btn btn-warning w-100"
            disabled
            style="pointer-events: none;"
          >VIEW</button>
        </span>`;
      }
    },
  },
];
